import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { InputModel } from '../../models';
import { InputWithoutSource } from '../../componentTypes';
import { GenericPercentageInput } from '../../components';


const TaxOnPremiumInput: InputWithoutSource = ({ input }) => (
    <GenericPercentageInput label={input.name} input={input} />
);

TaxOnPremiumInput.meta = {
    inputType: InputModel.name
};

export default observer(TaxOnPremiumInput);
